import React, { Fragment } from 'react'
import { ZoneStatusItem } from '../../../interfaces/WorkOrder/WorkOrder'
import {
  List,
  ListItem,
  ListItemText,
  ListItemSecondaryAction,
  IconButton,
  Box,
  Typography
} from '@mui/material'
import DoneIcon from '@mui/icons-material/Done'
import ErrorIcon from '@mui/icons-material/Error'

import { useStyles } from '../styles'

interface ValidatedZonesProps {
  zonesStatus: ZoneStatusItem[]
}

export const ValidatedZones: React.FC<ValidatedZonesProps> = ({
  zonesStatus
}) => {
  const classes = useStyles()
  const zoneIcon = (isValidated: boolean) => {
    return isValidated ? <DoneIcon /> : <ErrorIcon />
  }

  const zoneClassName = (isValidated: boolean) => {
    return isValidated
      ? `${classes.dispatchValidationSuccess}`
      : `${classes.dispatchValidationError}`
  }
  return (
    <Fragment>
      <List>
        {zonesStatus.map((zone) => (
          <ListItem
            key={zone.zoneName}
            disableGutters
            className={`${classes.zoneListItem}`}
          >
            <ListItemText
              primary={zone.zoneName}
              className={zoneClassName(zone.isValidated)}
            />
            <ListItemSecondaryAction>
              <IconButton edge='end' aria-label='comments'>
                {zoneIcon(zone.isValidated)}
              </IconButton>
            </ListItemSecondaryAction>
          </ListItem>
        ))}
      </List>

      <Box className={`${classes.zoneStatus}`}>
        <Box className={`${classes.zoneStatusItem}`}>
          <DoneIcon />
          <Typography className={`${classes.dispatchValidationSuccess}`}>
            Validada
          </Typography>
        </Box>
        <Box
          className={`${classes.zoneStatusItem}`}
          style={{ marginLeft: '25px' }}
        >
          <ErrorIcon />
          <Typography className={`${classes.dispatchValidationError}`}>
            Sin validar
          </Typography>
        </Box>
      </Box>
    </Fragment>
  )
}
